import { get, set, del } from 'idb-keyval';
import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';

const KEY = 'mos.query-cache';

/** IndexedDB persister (idb-keyval) with a throttled writer — offline reload shows the last data. */
export function createIdbPersister(): Persister {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending: PersistedClient | null = null;
  return {
    persistClient: async (client) => {
      pending = client;
      if (timer) return;
      timer = setTimeout(async () => {
        timer = null;
        const c = pending;
        pending = null;
        if (c) await set(KEY, c).catch(() => undefined);
      }, 1000);
    },
    restoreClient: async () => (await get<PersistedClient>(KEY).catch(() => undefined)) ?? undefined,
    removeClient: async () => {
      await del(KEY).catch(() => undefined);
    },
  };
}
